import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3378">
      <Navbar data-id="element-3379" />
      <main data-id="element-3380">
        <ConsularAffairs data-id="element-3381" />
      </main>
      <Footer data-id="element-3382" />
      <FeedbackPopup data-id="element-3383" />
    </div>;
}